<template>
    <div>
        <div class="agreement-container">
            <div class="title">
                <h4>{{pubAgreement.name}}</h4>
                <span class="date">{{pubAgreement.createTime}}</span>
            </div>
            <div class="content" v-html="pubAgreement.content">
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import comnApi from '../../api/comn'

    export default {
        name: 'swb-pub-agreement',
        desc: '查看公开协议',
        props: ['code'],
        data: function () {
            return {
                pubAgreement: {
                    name: '',
                    content: '',
                    createTime: null
                }
            }
        },
        created: function () {
            this.getOperatorPubAgreement();
        },
        methods: {
            getOperatorPubAgreement: function () {
                let self = this;
                let postData = {};
                postData.code = this.code;
                comnApi.getOperatorPubAgreement(postData, function (result) {
                    if(result.type == 'info') {
                        self.pubAgreement = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }

</script>
<style>
    .agreement-container .title {
        overflow: hidden;
        position: relative;
        border-bottom: 1px dashed #ddd;
    }

    .agreement-container .title > h4 {
        height: 28px;
        line-height: 28px;
        text-align: center;
        color: #2D8CF0;
        font-size: 16px;
    }

    .agreement-container .title > .date {
        font-size: 12px;
        color: #666;
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/compo/comn/PubAgreement.vue